(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.getElementById('videoWrapper');
  const overlay = document.getElementById('videoOverlay');
  const cursor = document.getElementById('customCursor');
  const soundToggle = document.getElementById('soundToggle');
  const video = wrapper.querySelector('video');

  if (!video) return;

  video.muted = true;
  video.play().catch(err => console.log('Autoplay blocked:', err));

  soundToggle.style.display = 'none';


  wrapper.addEventListener('mousemove', (e) => {
    if(window.innerWidth > 990 && !cursor.classList.contains('hidden')){
      const rect = wrapper.getBoundingClientRect();
      cursor.style.left = (e.clientX - rect.left) + 'px';
      cursor.style.top = (e.clientY - rect.top) + 'px';
    } else {
      cursor.style.left = '50%';
      cursor.style.top = '50%';
    }
  });

  overlay.addEventListener('click', function() {
    overlay.style.display = 'none';
    cursor.classList.add('hidden');  
    wrapper.style.cursor = 'default'; 
    soundToggle.style.display = 'flex';
    video.muted = false;
    video.play().catch(err => console.log('Video play blocked:', err));
  });

  soundToggle.addEventListener('click', function() {
    if(!video) return;

    video.muted = !video.muted;
    const iconSpan = soundToggle.querySelector('.icon');
    const textSpan = soundToggle.querySelector('.text');

    if(video.muted){
      textSpan.textContent = 'Turn on Sound';
      iconSpan.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M3 10v4h4l5 5V5L7 10H3z"/>
        </svg>
      `;
    } else {
      textSpan.textContent = 'Turn off Sound';
      iconSpan.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M3 10v4h4l5 5V5L7 10H3z"/>
          <path d="M16.5 12c0-1.77-.77-3.37-2-4.47v8.94c1.23-1.1 2-2.7 2-4.47z"/>
        </svg>
      `;
    }
  });

  video.addEventListener('ended', () => {
    video.currentTime = 0;
    video.play();
  });
});


  } catch(e) { console.error(e); }
})();
})();
